import * as RadixDropdown from '@radix-ui/react-dropdown-menu';
import { cx } from 'class-variance-authority';
import { forwardRef } from 'react';

type RadioGroupProps = RadixDropdown.DropdownMenuRadioGroupProps;

const RadioGroup = forwardRef<HTMLDivElement, RadioGroupProps>(({ children, className, ...props }, ref) => {
  return (
    <RadixDropdown.RadioGroup className={cx('p-1', className)} ref={ref} {...props}>
      {children}
    </RadixDropdown.RadioGroup>
  );
});

export default RadioGroup;
